<script setup lang="ts">
import { PromotionInternalProps } from "./PromotionInternal.props"
import CardPromoPromotion from "~/components/Card/Promo/Promotion.vue"
import type { HorizontalProps } from "~/components/Banner/DiscountPromo/Horizontal.props"
import type { PromotionProps } from "~/components/Card/Promo/Promotion.props"
import {
  VIEW_ITEM_LIST_IDS,
  VIEW_ITEM_LIST_NAMES
} from "~/utils/analytics/viewItemList"

const props = defineProps<PromotionInternalProps>()
const route = useRoute()
const aisComponent = ref(null)
const isAisComponentRendered = ref(false)

const serverRendered = useState(`server-rendered-${route.path}`, () => false)
onServerPrefetch(() => {
  serverRendered.value = true
})

watch(
  () => aisComponent.value,
  (newValue) => {
    isAisComponentRendered.value = !!newValue
  },
  { immediate: true }
)

const { setPageInfo } = usePageInfo()

setPageInfo({
  query: "",
  listingType: "promotion",
  filterString: `promotionCategories:"${props.promotionName}"`,
  pageTitle: ""
})
</script>

<template>
  <div class="grid-standard mb-4 md:mb-6">
    <UtilsBreadcrumbs
      v-bind="breadcrumbs"
      class="negative-margined col-span-full"
    />
    <BannerPromo
      v-if="promoBanner"
      v-bind="promoBanner"
      :background-image="{
        ...promoBanner?.backgroundImage,
        preload: true,
        imgAttrs: { fetchpriority: 'high' }
      }"
      class="negative-margined col-span-full md:mx-0"
    />
    <div class="col-span-full mt-4">
      <h1 v-if="title" class="hyppo-bold md:mammoth-bold mb-2">{{ title }}</h1>
      <h2 v-if="subtitle" class="pig md:elephant mb-2">{{ subtitle }}</h2>
      <UtilsMarkdown
        :content="description"
        v-if="description"
        class="beaver md:pig markdown__promotion-description"
      />
    </div>

    <div v-if="content" class="col-span-full">
      <DynamicContent class="cms-content mt-3 md:mt-11" :components="content" />
    </div>

    <div v-if="!hasAlgoliaListing" class="negative-margined col-span-full">
      <AlgoliaListingPage>
        <template #products="slotProps">
          <GAListPageList
            :name="VIEW_ITEM_LIST_NAMES.PROMO"
            :id="VIEW_ITEM_LIST_IDS.ON_SALE"
          >
            <GridListCategory
              ref="aisComponent"
              :products-list="slotProps.items"
              :list-name="VIEW_ITEM_LIST_NAMES.PROMO"
              :list-id="VIEW_ITEM_LIST_IDS.ON_SALE"
            />
          </GAListPageList>
        </template>
      </AlgoliaListingPage>
    </div>
    <div class="col-span-full" v-if="promotionsList?.length">
      <p class="hyppo-bold md:elephant-bold mb-6">
        {{ promotionsListTitle }}
      </p>
      <div class="grid-container md:gap-4">
        <div
          v-for="promotion in promotionsList"
          class="col-span-4"
          :key="promotion.title"
        >
          <BannerDiscountPromoHorizontal
            v-if="(promotion as HorizontalProps).cardType"
            v-bind="(promotion as HorizontalProps)"
            full-height
          />
          <CardPromoPromotion v-else v-bind="(promotion as PromotionProps)" />
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>

:deep(.cms-content) {
  .cmp-discount-rails {
    @apply mx-[-16px] md:mx-[-71px] lg:mx-[-228px];
  }
}

</style>
